import React, { Fragment } from 'react';
import { Page, Pane } from '../../atoms/applications/page';
import { ApplicationPageState } from '../../../containers/application/states/ApplicationPageState';
import { inject, observer } from 'mobx-react';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import './completePane.module.scss';
import { ApplicationErrorSummary } from '../../molecules/applications/ApplicationErrorSummary';
import classNames from 'classnames';
import { CompleteApplySectionMultiCreatorBanner } from '../multi_creator/CompleteApplyMultiCreatorBanner';

type Props = {
    applicationState: ApplicationPageState;
};

@inject('applicationState')
@observer
export class CompletePane extends React.Component<Props> {
    render() {
        const {
            applicationState: { complete, error },
        } = this.props;
        return (
            <>
                <Page styleName="compelte_page">
                    <Pane styleName="pane">
                        <div styleName="subtitle-wrapper">
                            <div styleName="subtitle">お申し込みが完了しました</div>
                            <div styleName="subtitle-inner">
                                {error ? (
                                    <>
                                        <Fragment>
                                            お申し込みは完了しましたが、月額料金の支払いに失敗しました。<br />以下の要因を参考にして、マイページから<br />クレジットカード情報を更新してください
                                        </Fragment>
                                        <hr />
                                        <ApplicationErrorSummary title="考えられる要因" type="complete">
                                            ・クレジットカードが限度額に達していた<br />
                                            ・カードの有効期限切れ<br />
                                            ・引き落とし先の銀行口座の残高不足<br />
                                            など
                                        </ApplicationErrorSummary>
                                    </>
                                ) : (
                                    <Fragment>
                                        お申し込み完了メールをご登録いただいたメールアドレスへ<br />送信しましたのでご確認ください
                                    </Fragment>
                                )}
                            </div>
                        </div>
                        <div styleName="header">WELCOME TO SHElikes</div>
                        <div styleName="message">
                            ようこそSHElikesへ！<br />あなたらしい働き方を叶える第一歩の始まりです。<br />これから始まるあなたの新たな挑戦を<br />SHEは全力でサポートしていきます。<br />一緒に頑張っていきましょう！
                        </div>
                        <div styleName="button-wrapper">
                            <Button id="start-she-button" type="primary" size="l" onClick={complete} styleName="button">
                                さっそくはじめる
                            </Button>
                        </div>
                        <div styleName={classNames('welcome-she-chan', { error: error })} />
                        <div styleName="wakuwaku-background" />
                    </Pane>
                </Page>
                <CompleteApplySectionMultiCreatorBanner />
                <div styleName="wakuwaku-background-top" />
            </>
        );
    }
}
